import api from './base/BaseApi';
import { handleApiError } from './base/handleApiError';
import {
  TGetGeneralLedgerCodeResponse,
  TGetGeneralLedgerCodesRequestParams,
  TGeneralLedgerCodesEnabledResponse,
  IUpdateTransactionGeneralLedgerCodeRequest,
  IUpdateGeneralLedgerCodeSetRequest,
  TGeneralLedgerCodeRemovedResponse,
  IUpdateGeneralLedgerCodeRequest,
  ICreateGeneralLedgerCodeRequest
} from './types/GeneralLedgerCodeData';

const getGeneralLedgerCodesRequestParam = (options: TGetGeneralLedgerCodesRequestParams) => {
  const { archived, search } = options || {};

  const urlParams = new URLSearchParams();

  if (archived) {
    urlParams.append('archived', archived.toString());
  }

  if (search) {
    urlParams.append('search', search);
  }

  return urlParams.toString();
};

export const createGeneralLedgerCode = async (
  businessId: string,
  request: ICreateGeneralLedgerCodeRequest
) =>
  api
    .post<TGetGeneralLedgerCodeResponse, ICreateGeneralLedgerCodeRequest>(
      `api/v1/businesses/${businessId}/general-ledger-codes`,
      request
    )
    .then((response) => response)
    .catch(handleApiError);

export const updateGeneralLedgerCode = async (
  businessId: string,
  codeId: string,
  request: IUpdateGeneralLedgerCodeRequest
) =>
  api
    .patch(`api/v1/businesses/${businessId}/general-ledger-codes/${codeId}`, request)
    .then((response) => response)
    .catch(handleApiError);

export const removeGeneralLedgerCode = async (businessId: string, codeId: string) =>
  api
    .delete<TGeneralLedgerCodeRemovedResponse, null>(
      `api/v1/businesses/${businessId}/general-ledger-codes/${codeId}`
    )
    .then((response) => response)
    .catch(handleApiError);

export const updateGeneralLedgerCodeSet = async (
  businessId: string,
  request: IUpdateGeneralLedgerCodeSetRequest
) =>
  api
    .patch(`api/v1/businesses/${businessId}/general-ledger-codes`, request)
    .then((response) => response)
    .catch(handleApiError);

export const getGeneralLedgerCodes = async (
  businessId: string,
  options: TGetGeneralLedgerCodesRequestParams
) =>
  api
    .get<TGetGeneralLedgerCodeResponse[]>(
      `api/v1/businesses/${businessId}/general-ledger-codes?${getGeneralLedgerCodesRequestParam(options)}`
    )
    .then((response) => response)
    .catch(handleApiError);

export const getGeneralLedgerCodesEnabled = async (businessId: string) =>
  api
    .get<TGeneralLedgerCodesEnabledResponse>(
      `api/v1/businesses/${businessId}/general-ledger-codes-enabled`
    )
    .then((response) => response)
    .catch(handleApiError);

export const updateTransactionGeneralLedgerCode = async (
  transactionId: string,
  request: IUpdateTransactionGeneralLedgerCodeRequest
) =>
  api
    .patch(`api/v1/transactions/${transactionId}/general-ledger-code`, request)
    .then((response) => response)
    .catch(handleApiError);

export const removeTransactionGeneralLedgerCode = async (transactionId: string) =>
  api
    .delete(`api/v1/transactions/${transactionId}/general-ledger-code`)
    .then((response) => response)
    .catch(handleApiError);
